module.exports = __webpack_public_path__ + "img/lead.a83defc8.svg";